import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { MalwareDisputeRequest, MalwareDisputeResponse } from '../../../../shared/issuesV2';

type CreateMalwareDisputeVariables = {
  issueId: number;
  reason: MalwareDisputeRequest['reason'];
  comment: string;
};

function createMalwareDispute(
  { issueId, reason, comment }: CreateMalwareDisputeVariables,
): Promise<Response & { data?: MalwareDisputeResponse }> {
  return post<MalwareDisputeRequest, MalwareDisputeResponse>(`/api/v2/issues/${issueId}/disputes`, { reason, comment });
}

/** Hook for creating a malware issue dispute via the issues V2 disputes endpoint. */
export function useCreateMalwareDispute() {
  return useToastedMutation({
    mutationFn: createMalwareDispute,
    successToastMessage: 'Malware dispute submitted successfully.',
    errorToastMessage: 'Failed to submit malware dispute.',
  });
}
